// extracted by mini-css-extract-plugin
module.exports = {"warning":"style_warning__xzB8m","icon":"style_icon__3Q4Uo","content":"style_content__oGRqH"};